/**
 * 都道府県の列挙クラス
 * @param code : 都道府県コード
 * @param name : 都道府県名(漢字)
 * @param name_r : 都道府県名(ローマ字)
 */
const _prefs = [
  { "code": '01', "name": '北海道' , "name_r": 'hokkaido' },
  { "code": '02', "name": '青森県' , "name_r": 'aomori' },
  { "code": '03', "name": '岩手県' , "name_r": 'iwate' },
  { "code": '04', "name": '宮城県' , "name_r": 'miyagi' },
  { "code": '05', "name": '秋田県' , "name_r": 'akita' },
  { "code": '06', "name": '山形県' , "name_r": 'yamagata' },
  { "code": '07', "name": '福島県' , "name_r": 'fukushima' },
  { "code": '08', "name": '茨城県' , "name_r": 'ibaraki' },
  { "code": '09', "name": '栃木県' , "name_r": 'tochigi' },
  { "code": '10', "name": '群馬県' , "name_r": 'gunma' },
  { "code": '11', "name": '埼玉県' , "name_r": 'saitama' },
  { "code": '12', "name": '千葉県' , "name_r": 'chiba' },
  { "code": '13', "name": '東京都' , "name_r": 'tokyo' },
  { "code": '14', "name": '神奈川県' , "name_r": 'kanagawa' },
  { "code": '15', "name": '新潟県' , "name_r": 'niigata' },
  { "code": '16', "name": '富山県' , "name_r": 'toyama' },
  { "code": '17', "name": '石川県' , "name_r": 'ishikawa' },
  { "code": '18', "name": '福井県' , "name_r": 'fukui' },
  { "code": '19', "name": '山梨県' , "name_r": 'yamanashi' },
  { "code": '20', "name": '長野県' , "name_r": 'nagano' },
  { "code": '21', "name": '岐阜県' , "name_r": 'gifu' },
  { "code": '22', "name": '静岡県' , "name_r": 'shizuoka' },
  { "code": '23', "name": '愛知県' , "name_r": 'aichi' },
  { "code": '24', "name": '三重県' , "name_r": 'mie' },
  { "code": '25', "name": '滋賀県' , "name_r": 'shiga' },
  { "code": '26', "name": '京都府' , "name_r": 'kyoto' },
  { "code": '27', "name": '大阪府' , "name_r": 'osaka' },
  { "code": '28', "name": '兵庫県' , "name_r": 'hyogo' },
  { "code": '29', "name": '奈良県' , "name_r": 'nara' },
  { "code": '30', "name": '和歌山県' , "name_r": 'wakayama' },
  { "code": '31', "name": '鳥取県' , "name_r": 'tottori' },
  { "code": '32', "name": '島根県' , "name_r": 'shimane' },
  { "code": '33', "name": '岡山県' , "name_r": 'okayama' },
  { "code": '34', "name": '広島県' , "name_r": 'hiroshima' },
  { "code": '35', "name": '山口県' , "name_r": 'yamaguchi' },
  { "code": '36', "name": '徳島県' , "name_r": 'tokushima' },
  { "code": '37', "name": '香川県' , "name_r": 'kagawa' },
  { "code": '38', "name": '愛媛県' , "name_r": 'ehime' },
  { "code": '39', "name": '高知県' , "name_r": 'kochi' },
  { "code": '40', "name": '福岡県' , "name_r": 'fukuoka' },
  { "code": '41', "name": '佐賀県' , "name_r": 'saga' },
  { "code": '42', "name": '長崎県' , "name_r": 'nagasaki' },
  { "code": '43', "name": '熊本県' , "name_r": 'kumamoto' },
  { "code": '44', "name": '大分県' , "name_r": 'oita' },
  { "code": '45', "name": '宮崎県' , "name_r": 'miyazaki' },
  { "code": '46', "name": '鹿児島県' , "name_r": 'kagoshima' },
  { "code": '47', "name": '沖縄県' , "name_r": 'okinawa' },
]

export default {
  data () {
    return {
      prefs: _prefs,
    }
  }
}

